<!-- 消息设置 -->
<template>
  <Layout class="yscLayout">
    <YscHeader
      :style="{position: 'fixed', zIndex: 999, width: '100%'}"
      :headerMenus="headerMenus"
      :userInfo="userInfo"
      :appId="appId"
      :sellerList="sellerList"
      :sellerFetch="sellerFetch"
      :sellerChange="sellerChange"
      :defaultSeller="defaultSeller"
      :noticeList="noticeData"
      :targetNotice="targetNotice"
      :moreNoticeFetch="moreNoticeFetch"
      :readNoticeFetch="readNoticeFetch"
      :readAllNoticeFetch="readAllNoticeFetch"
      :windowOpen="windowOpen"
      :logoutFun="logoutFun"
      align="center"
      v-if="hasHeader" />

    <Layout :style="hasHeader ? {marginLeft: '200px', marginTop: '55px'} : {}">
      <YscSider
        :style="{position: 'fixed', zIndex: 999, height: '100vh', left: 0, top: '55px', overflow: 'auto'}"
        :siderMenus="siderMenus" :activeMenu="activeMenu"
        v-if="hasHeader" />
      <Layout>
        <Content :style="{padding: '15px', minHeight: 'calc(100vh - 55px)', backgroundColor: '#ffffff'}">
          <router-view />
        </Content>
      </Layout>
    </Layout>
  </Layout>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import ComUrl from '../../request/common'
import Cookies from 'js-cookie'
import { setTimeout } from 'timers'
import { YscClstags } from '@/utils/clstags'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      headerMenus: [],
      userInfo: {},
      sellerList: [],
      siderMenus: null,
      noticeData: {
        hasMore: false, // 是否展示'加载更多'
        unReadCount: 0, // 如果有数据传count数，如果没有则传0
        data: []
      },
      count: 0,
      appId: 9999,
      isPerm: false,
      currentUser: {},
      defaultSeller: '请选择商家',
      activeMenu: 10601,
      targetNotice: {},
      // 是否显示header & slider
      hasHeader: true,
      // 埋点
      yscClstags: YscClstags
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    $route(){
      this.getLink(this.siderMenus && this.siderMenus.children, this.$route.path)
    }
  },
  // 方法集合
  methods: {
    sellerFetch (keyCode) {
      // console.log(keyCode)
      this.getSellerListData(keyCode)
    },
    sellerChange (code) {
      // console.log('change',code)
      let sellerName = this.sellerList.find(v => v.value === code) && this.sellerList.find(v => v.value === code).label
      Cookies.set('sellerPin', code)
      Cookies.set('sellerName', sellerName)
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    },
    getHeaderMenuData (userPin) {
      ComUrl.getUserMenu({ userName: userPin }).then(res => {
        if (res.success) {
          this.headerMenus = res.body
          this.headerMenus = this.headerMenus.sort(({appId: a}, {appId: b}) => a == 8 ? -1 : (b == 8 ? 1 : a - b))
          // 埋点
          this.headerMenus.map((item, i) => {
            // console.log(item)
            switch (item.appId) {
              case 1:
                item['clstag'] = this.yscClstags.header['il']
                break
              case 2:
                item['clstag'] = this.yscClstags.header['ihs']
                break
              case 3:
                item['clstag'] = this.yscClstags.header['sfs']
                break
              case 4:
                item['clstag'] = this.yscClstags.header['pbs']
                break
              case 5:
                item['clstag'] = this.yscClstags.header['vrs']
                break
              case 6:
                item['clstag'] = this.yscClstags.header['report']
                break
              case 7:
                item['clstag'] = this.yscClstags.header['auth']
                break
              case 8:
                item['clstag'] = this.yscClstags.header['home']
                break
              case 9:
                item['clstag'] = this.yscClstags.header['pisc']
                break
            }
          })
          this.defaultSeller = Cookies.get('sellerName')
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    getSellerListData (keyWords) {
      ComUrl.getSellerList({ sellerName: keyWords }).then(res => {
        if (res.success) {
          this.sellerList = res.body
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    getUnReadCountData () {
      ComUrl.getUnReadCount().then(res => {
        if (res.success) {
          this.noticeData.unReadCount = Number(res.message)
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    getMessageListData (pages) {
      ComUrl.getMessageList({ offset: pages }).then(res => {
        if (res.success) {
          this.noticeData.data.push(...res.body.result)
          this.getUnReadCountData()
          if (this.noticeData.data.length < res.body.totalCount) {
            this.noticeData.hasMore = true
          } else {
            this.noticeData.hasMore = false
          }
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    moreNoticeFetch () {
      // console.log('fetch notices!')
      this.getMessageListData(++this.count)
      // console.log(this.count)
    },
    readNoticeFetch (noticeId) {
      // console.log('fetch noticeId!===', noticeId)
      ComUrl.readMessage({ id: noticeId }).then(res => {
        this.targetNotice = res
        if (res.success) {
          this.noticeData.data.find(item => item.id === noticeId).status = res.body[0].status
          this.getUnReadCountData()
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    readAllNoticeFetch () {
      // console.log('fetch readAllNotice!')
      ComUrl.readAllMessage().then(res => {
        if (res.success) {
          this.$Notice.success({
            title: '成功',
            desc: res.message
          })
          this.noticeData.data = []
          this.getMessageListData(0)
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    windowOpen (type) {
      // console.log(type)
      let url = ''
      if (type === 'sellerPlatform') {
        url = '//eclp.jd.com'
      } else if (type === 'buyerService') {
        url = '//fw.jd.com/772005.html'
      } else if (type === 'newerGuide') {
        url = '//ysc.jd.com/guide/il'
      } else if (type === 'showAllNotices') {
        url = '//ysc.jd.com/message/reminder'
      } else if (type === 'noticeSet') {
        url = '//ysc.jd.com/message/sellerRemind'
      }
      window.open(url)
    },
    logoutFun () {
      ComUrl.logout().then(res => {
        if (res.success) {
          this.$Notice.success({
            title: '提示',
            desc: res.message
          })
          Cookies.remove('sellerPin', { path: '/' })
          Cookies.remove('sellerName', { path: '/' })
          Cookies.remove('sso.jd.com', { domain: '.jd.com' })
          location.href = '/'
        } else {
          this.$Notice.error({
            title: '提示',
            desc: res.message
          })
        }
      })
    },
    getLink (menus,path){
      menus.map(item=>{
        if(item.children){
          this.getLink(item.children,path)
        }
        if(item.linkUrl == path){
          setTimeout(()=>{
            this.activeMenu = item.resId
          })
          // console.log(this.activeMenu)
        }
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // this.getLoggingValidData(this.$route.path)
    this.siderMenus = {
      "appId": 106, // 自定义侧边id
      "children": [
        {
          "appId": 106,
          "resId": 10601,
          "resName": "消息提醒设置",
          "appName": "消息提醒",
          "linkUrl": "/message/sellerRemind",
          "resType": "2",
          "parentId": 106,
          "hasChild": 0,
          "iconType": 'ios-pie-outline'
        },
        {
          "appId": 106,
          "resId": 10602,
          "resName": "全部消息",
          "appName": "消息提醒",
          "linkUrl": "/message/reminder",
          "resType": "2",
          "parentId": 106,
          "hasChild": 0,
          "iconType": 'ios-pie-outline'
        }
      ],
    }
    this.getLink(this.siderMenus && this.siderMenus.children, this.$route.path)
    ComUrl.queryUserInfo().then(res => {
      // console.log(res)
      if (res.success) {
        // console.log(res.body)
        // this.userName = res.data.userName
        this.userInfo = res.body
        this.getHeaderMenuData(this.userInfo.userPin)
        this.getSellerListData()
        // 只有当userType == '2' 时，需要调用此接口（适用于所有相关应用）!!!!
        if (this.userInfo && this.userInfo.userType == '2') {
          this.getMessageListData(this.count)
        }
      } else {
        this.$Notice.error({
          title: '提示',
          desc: res.message
        })
      }
    })
    if (this.$route.query.noheader == 'true') {
      this.hasHeader = false
    } else {
      this.hasHeader = true
    }
  }
}
</script>

<style lang='scss'>
//@import url(); 引入公共css类
// @import url('./../../assets/scss/common.scss');
.yscLayout{
  .layoutNav {
    .ivu-menu-item{
      // padding: 0 15px;
      font-size: 16px;
    }
  }
  .userOpts .userName {
    .ivu-icon {
      vertical-align: middle;
    }
  }
}
@media (min-width: 1440px) {
  .yscLayout {
    .layoutNav {
      margin-left: 6%;
    }
  }
}
</style>
